// extracted by mini-css-extract-plugin
module.exports = {"header":"QuickLinks_header__7j1nm","quickLinksContainer":"QuickLinks_quickLinksContainer__azLk0","link":"QuickLinks_link__GzlyR"};